import { CmsLatestReactionAvatars } from './CmsLatestReactionAvatars';
import { CmsReactionsSummaryContainer } from './CmsReactions.styled';
import { useCmsReactionsContext } from './CmsReactionsContext';
import { CmsTotalReactionsHeading } from './CmsTotalReactionsHeading';

export function CmsReactionsSummary() {
  const { latestReactions, totalReactions } = useCmsReactionsContext();

  if (latestReactions.length === 0 && totalReactions === 0) {
    return null;
  }

  return (
    <CmsReactionsSummaryContainer>
      <CmsLatestReactionAvatars />
      <CmsTotalReactionsHeading />
    </CmsReactionsSummaryContainer>
  );
}
